import { useEffect, useState } from "react";
import paymentsApi from "../../api/payment/payment";
import trainingTypeApi from "../../api/trainingType/trainingType";
import DataHandlerHelper from "../../helpers/DataHandler.helper";
import { localDayStartISO } from "../../helpers/dateFormat";
import { ui } from "../../helpers/ui";

const InitPaymentsLogic = () => {
  const [payments, setPayments] = useState<any[]>([]);
  // id -> naziv tipa treninga, da i tipovi dodati kroz Usluge imaju naziv
  const [typeNames, setTypeNames] = useState<Record<number, string>>({});
  const [data, setData] = useState<any>({
    fromDate: "",
    toDate: "",
  });

  useEffect(() => {
    trainingTypeApi
      .getTrainingTypes()
      .then((response) => {
        if (response.status === 200) {
          const map: Record<number, string> = {};
          for (const tt of response.data ?? []) map[tt.id] = tt.name;
          setTypeNames(map);
        }
      })
      .catch(() => {
        // Nazivi padaju na ugradjenu mapu
      });
  }, []);

  const loadPayments = () => {
    if (new Date(data.fromDate).toString() === "Invalid Date") {
      ui.alert("Neispravan datum Od");
      return;
    }
    if (new Date(data.toDate).toString() === "Invalid Date") {
      ui.alert("Neispravan datum Do");
      return;
    }
    paymentsApi
      .getPaymentsBetween({
        fromDate: localDayStartISO(data.fromDate),
        toDate: localDayStartISO(data.toDate),
      })
      .then((response) => {
        if (response.status === 200) {
          setPayments(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onChange = (event: any) => {
    setData(DataHandlerHelper.handleInputChange(event, { ...data }));
  };

  return {
    data,
    payments,
    typeNames,
    onChange,
    loadPayments,
  };
};

export default InitPaymentsLogic;
